<div class="account-menu">
    <form *ngIf="loggedinuser==null" class="account-menu__form">
        <div class="account-menu__form-title">Log In to Your Account</div>
        <div class="form-group">
            <label for="header-signin-email" class="sr-only">Email address</label>
            <input [(ngModel)]="model.email" name="email" id="header-signin-email" type="email" class="form-control form-control-sm" placeholder="Email address">
        </div>
        <div class="form-group">
            <label for="header-signin-password" class="sr-only">Password</label>
            <div class="account-menu__form-forgot">
                <input [(ngModel)]="model.password" name="password" id="header-signin-password" type="password" class="form-control form-control-sm" placeholder="Password">
                 <a [routerLink]="['/auth/forgotpassword']" class="account-menu__form-forgot-link">Forgot?</a>
            </div>
        </div>
        <div class="form-group account-menu__form-button">
            <button (click)="login()" type="button" class="btn btn-primary btn-sm">Login</button>
        </div>
        <div class="account-menu__form-link"><a routerLink="/auth/index" (click)="closeMenu.emit()">Create An Account</a></div>
    </form>
    <div class="account-menu__divider"></div>
    <a *ngIf="loggedinuser!=null" routerLink="/dashboard" class="account-menu__user" (click)="closeMenu.emit()">
        <div class="account-menu__user-avatar">
            <img *ngIf="(loggedinuser.image==undefined)" src="./assets/images/avatars/avatar-1.jpg" alt="Profile Image">
            <img *ngIf="(loggedinuser.image!=undefined)" src="{{environment.baseurl+ loggedinuser.image}}" alt="Profile Image">
        </div>
        <div class="account-menu__user-info">
            <div class="account-menu__user-name">{{loggedinuser.fullname}}</div>
            <div class="account-menu__user-email">{{loggedinuser.email}}</div>
        </div>
    </a>
    <div *ngIf="loggedinuser!=null" class="account-menu__divider"></div>
    <ul *ngIf="loggedinuser!=null"  class="account-menu__links">
        <li><a routerLink="/dashboard/index" (click)="closeMenu.emit()">Edit Profile</a></li>
    </ul>
    <div class="account-menu__divider"></div>
    <ul *ngIf="loggedinuser!=null" class="account-menu__links">
        <li><a (click)="logout()">Logout</a></li>
    </ul>
</div>
